import React, { FC } from 'react';
import moment from 'moment';
import { CheckOutlined, ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { COMPLIANCE_EXPIRY_STATUSES } from '../../types/ComplianceTypes';
import {
	COMPLIANCE_EXPIRY_STATUS_COLORS,
	COMPLIANCE_EXPIRY_STATUS_DISPLAY_NAMES,
} from './ComplianceConstants';

const EXPIRY_ICONS = {
	[COMPLIANCE_EXPIRY_STATUSES.UP_TO_DATE]: CheckOutlined,
	[COMPLIANCE_EXPIRY_STATUSES.EXPIRING_SOON]: WarningOutlined,
	[COMPLIANCE_EXPIRY_STATUSES.EXPIRED]: ExclamationCircleOutlined,
};

interface ComplianceExpiryDisplayProps {
	expiryStatus?: string;
	expiryDate?: string;
	className?: string;
}

export const ComplianceExpiryDisplay: FC<ComplianceExpiryDisplayProps> = ({
	expiryStatus,
	expiryDate,
	className = '',
}): React.ReactElement => {
	if (!expiryStatus && !expiryDate) {
		return <span className="text-character-secondary">--</span>;
	}
	const color = COMPLIANCE_EXPIRY_STATUS_COLORS[expiryStatus];
	const IconComponent = EXPIRY_ICONS[expiryStatus];
	const dateIsHighlighted =
		expiryStatus === COMPLIANCE_EXPIRY_STATUSES.EXPIRING_SOON ||
		expiryStatus === COMPLIANCE_EXPIRY_STATUSES.EXPIRED;
	return (
		<span className={`inline-flex flex-col ${className}`}>
			{expiryStatus ? (
				<span className="inline-flex flex-row items-center gap-1">
					{IconComponent ? <IconComponent style={{ color }} /> : null}
					<span>{COMPLIANCE_EXPIRY_STATUS_DISPLAY_NAMES[expiryStatus] || expiryStatus}</span>
				</span>
			) : null}
			{expiryDate ? (
				<span style={dateIsHighlighted ? { color } : undefined}>
					{moment(expiryDate).format('D MMM, YYYY')}
				</span>
			) : null}
		</span>
	);
};
